/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */
export const isLocalEnv = () =>
  process.browser && location.hostname === 'localhost';
